///<reference path="skyward.ui.reporting.js"/>

(
function (skyward)
{
    skyward.reporting = skyward.reporting || {};

    skyward.reporting.getAggregateColumnFieldType = function (relatedColumnFieldType, aggregateType)
    {
        let fieldType = aggregateTypes[aggregateType] || relatedColumnFieldType;

        if (typeof fieldType === "object")
        {
            return fieldType[relatedColumnFieldType];
        }

        return fieldType;
    };

    skyward.reporting.reportColumn = 
    {
        getFieldType: function (columnData)
        {
            var fieldColumnType = columnData.fieldColumnType;
            var fieldType = columnData.fieldType;
            if (fieldColumnType === skyward.reporting.COLUMN_TYPES.AGGREGATE_COLUMN)
            {
                return skyward.reporting.getAggregateColumnFieldType(columnData.columnFieldType, columnData.aggregateType);
            }
            else if (fieldColumnType === skyward.reporting.COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN || columnData.columnFieldType === "Image")
            {
                fieldType = "Image";
            }
            return fieldType || columnData.columnFieldType;
        }
    };
    
    var string = "String",
        byte = "Number Byte",
        short = "Number Short",
        int = "Number Int",
        long = "Number Long",
        decimal = "Number Decimal",
        dateTime = "DateTime";

    var aggregateTypes = 
    {
        AlphabeticMax: string,
        AlphabeticMin: string,
        Average: decimal,
        ConcatenateAll: string,
        ConcatenateAllExcludeBlanks: string,
        ConcatenateDistinct: string,
        ConcatenateDistinctExcludeBlanks: string,
        Count: int,
        CountFalse: int,
        CountTrue: int,
        DateTimeMax: dateTime,
        DateTimeMin: dateTime,
        DistinctCount: int,
        Median: decimal,
        StandardDeviation: decimal,
        Sum: {
            "Number Short": int,
            "Number Byte": int,
            "Number Int": int,
            "Number Long": long,
            "Number Decimal": decimal
        },//https://msdn.microsoft.com/en-us/library/ms187810.aspx
        Variance: decimal
        //LastNonBlankRecordValue, LastRecordValue, NumericMax, NumericMin //these should fall through to the column's field type
    };

}(window.skyward = window.skyward || {})
);